// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"6b2acbb9","455":"a6ade081","977":"5fb10625"}[chunkId] + ".chunk.js";
};